import React from 'react';

import { Box, Typography } from '@mui/material';

import { useScreenInfo } from 'src/hooks/common';
import { SxProp } from 'src/types/mui';

interface ResourcesPageGroupProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
  contentStyles?: SxProp;
}

export const ResourcesPageGroup: React.FC<ResourcesPageGroupProps> = ({
  title,
  subtitle,
  children,
  contentStyles,
}) => {
  const { isMobile } = useScreenInfo();

  return (
    <Box>
      <Typography variant={isMobile ? 'subtitle1' : 'h5'} sx={isMobile ? { px: 2 } : {}}>
        {title}
      </Typography>
      <Typography
        variant={isMobile ? 'body2' : 'body1'}
        color="text.secondary"
        mt={1}
        sx={isMobile ? { px: 2 } : {}}
      >
        {subtitle}
      </Typography>
      <Box mt={2} sx={contentStyles}>
        {children}
      </Box>
    </Box>
  );
};
